export const PreferencesGetters = {
  TolObjects: 'TolObjects',
  TolActions: 'TolActions',
  Preferences: 'Preferences',
  IsPreferenceSet: 'IsPreferenceSet',
  NewPreferences: 'PreferencesGetters.NewPreferences',
  AllowedPreferences: 'PreferencesGetters.AllowedPreferences'
};

export const PreferencesMutations = {
  RetrievePreferencesSuccess: 'RetrievePreferencesSuccess',
  InsertNewPreference: 'PreferencesMutations.InsertNewPreference',
  RemoveNewPreference: 'PreferencesMutations.RemoveNewPreference'
};

export const PreferencesActions = {
  RetrievePreferences: 'retrievePreferences',
  AddPreference: 'addPreference',
  DeletePreference: 'deletePreference',
  UpdatePreference: 'updatePreference'
};
